import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Components/Navbar";
import SideBar from "./Components/SideBar";
import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultWallets, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import {
  Chain,
  configureChains,
  createClient,
  goerli,
  mainnet,
  sepolia,
  WagmiConfig,
} from "wagmi";
import { publicProvider } from "wagmi/providers/public";

import { bscTestnet } from "@wagmi/chains";
import NavBarsec from "./Components/NavBarsec";
import {infuraProvider} from "wagmi/providers/infura"

// const { chains, provider } = configureChains(
//   [sepolia, bscTestnet],
//   [publicProvider()]
// );
const { chains, provider } = configureChains(
  [ bscTestnet,  sepolia],
  [
    infuraProvider({
      apiKey: "8bae4abd9f7842c487237656f0d15e3c",
      priority: 0,
    }),
    publicProvider({priority:1}),
  ]
);

const { connectors } = getDefaultWallets({ appName: "Dio_send", chains });
const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

const FrontView = () => {
  return (
    <div>
      <WagmiConfig client={wagmiClient}>
        <RainbowKitProvider chains={chains}>
          <div className="">
            <NavBarsec />
          </div>

          <div className="flex ">
            <SideBar />

            <div className=" w-full">
              <Outlet />
            </div>
          </div>
        </RainbowKitProvider>
      </WagmiConfig>
    </div>
  );
};

export default FrontView;
